export default "__VITE_ASSET__BvDHyXxB__"